import { Heading, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { useMantineTheme } from "@mantine/core";
import dayjs from "dayjs";
import { FC, MutableRefObject } from "react";
import { useLocale } from "../../../hooks/useLocale";
import { timestampColumnWidth } from "./TimestampColumn";

const borderColor = "rgba(0,0,0,0.1)";

const TimestampHeaderCell = styled.div`
  width: ${timestampColumnWidth}px;
  border-bottom: 1px solid ${borderColor};
`;
const HeaderCell = styled.div`
  border-left: 1px solid ${borderColor};
  border-bottom: 1px solid ${borderColor};
  padding: 10px;
  padding-top: 12px;
  padding-bottom: 8px;

  display: flex;
  flex-direction: column;
  align-items: center;

  gap: 2px;
`;

type HeadersProps = {
  timestampHeaderRef: MutableRefObject<HTMLDivElement | null>;
  dates: Date[];
  gridWidth: number;
};
export const Headers: FC<HeadersProps> = ({
  timestampHeaderRef,
  dates,
  gridWidth,
}) => {
  const { locale } = useLocale();
  const theme = useMantineTheme();
  const highlightColor = theme.colors.green[7];

  const now = new Date();
  const isDateToday = (date: Date) => dayjs(date).isSame(now, "day");

  return (
    <>
      <TimestampHeaderCell ref={timestampHeaderRef} />

      {dates.map((date, dayi) => {
        const dateIsToday = isDateToday(date);
        return (
          <HeaderCell key={dayi}>
            <Heading as="h3" size="sm" textTransform={"capitalize"}>
              {dayjs(date).format(gridWidth > 1100 ? "dddd" : "ddd")}
            </Heading>
            <Text
              borderRadius="1.7em"
              height="1.7em"
              width="1.7em"
              backgroundColor={dateIsToday ? highlightColor : "transparent"}
              color={dateIsToday ? "#fff" : "inherit"}
              display="flex"
              justifyContent={"center"}
              alignItems={"center"}
            >
              {date
                .toLocaleDateString(locale, { day: "numeric" })
                .replace(".", "")}
            </Text>
          </HeaderCell>
        );
      })}
    </>
  );
};
